
import { convertDateBrComHoraSafe } from "@/core/helpers/convertDate";
import {
  defineComponent,
  PropType,
  onMounted,
  reactive,
  watch,
  toRefs,
} from "vue";
export default defineComponent({
  name: "Grade-Edicao",
  data() {
    return {
      dataInclusao: "",
      dataAlteracao: "",
    };
  },
  props: {
    propPayload: {
      type: Object as PropType<any>,
      required: true,
      default: () => {
        return {};
      },
    },
    porpHideHr: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideDataInclusao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideUsuarioInclusao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideUsuarioAlteracao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideDataAlteracao: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const data = reactive({
      dataInclusao: "",
      dataAlteracao: "",
    });

    const updateDates = () => {
      data.dataInclusao = convertDateBrComHoraSafe(
        props.propPayload?.data_inclusao as any
      );
      data.dataAlteracao = convertDateBrComHoraSafe(
        props.propPayload?.data_alteracao as any
      );
    };

    onMounted(() => {
      updateDates();
    });

    watch(
      () => props.propPayload?.data_inclusao,
      () => {
        data.dataInclusao = convertDateBrComHoraSafe(
          props.propPayload?.data_inclusao as any
        );
      },
      { immediate: true }
    );

    watch(
      () => props.propPayload?.data_alteracao,
      () => {
        data.dataAlteracao = convertDateBrComHoraSafe(
          props.propPayload?.data_alteracao as any
        );
      },
      { immediate: true }
    );

    return {
      ...toRefs(data),
    };
  },
});
